/**
 * دانلودِ فایل با **نامی که سرور تعیین کرده**.
 *
 * چرا: تا اینجا هر صداکننده نامِ فایل را خودش می‌ساخت و هدرِ `Content-Disposition`
 * نادیده می‌ماند — برای همین فیشِ حقوقی با اینکه سرور «مریم حیدری تیر ۱۴۰۵.pdf»
 * می‌فرستاد، `payslip_121_3.pdf` ذخیره می‌شد.
 *
 * دو نکته که بدونشان کار نمی‌کند:
 *  • سرور باید `expose_headers=["Content-Disposition"]` بدهد، وگرنه مرورگر اصلاً
 *    این هدر را به JS نشان نمی‌دهد (در `main.py` اضافه شد).
 *  • نامِ فارسی طبقِ RFC 5987 در `filename*=UTF-8''…` درصدکدشده می‌آید؛ اول همان
 *    خوانده می‌شود و اگر نبود سراغِ `filename="…"` و در نهایت نامِ جایگزین می‌رویم.
 */

/** نامِ فایل را از هدرِ Content-Disposition بیرون می‌کشد (یا null). */
export function filenameFromHeader(disposition) {
  if (!disposition) return null;
  const star = /filename\*\s*=\s*UTF-8''([^;]+)/i.exec(disposition);
  if (star) {
    try { return decodeURIComponent(star[1].trim()); } catch { /* هدرِ خراب */ }
  }
  const plain = /filename\s*=\s*"?([^";]+)"?/i.exec(disposition);
  return plain ? plain[1].trim() : null;
}

/** بلاب را با نامِ داده‌شده در مرورگر ذخیره می‌کند. */
export function saveBlob(blob, filename) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}

/**
 * پاسخِ axios (با `responseType: "blob"`) را ذخیره می‌کند.
 * اولویت: نامِ سرور ← `fallback`.
 */
export function saveResponse(res, fallback = "download") {
  const name = filenameFromHeader(
    res?.headers?.["content-disposition"] || res?.headers?.get?.("content-disposition"));
  saveBlob(res.data, name || fallback);
  return name || fallback;
}
